import { COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS } from '@core/components/component-factory/component-factory-config-input.registry';
import type { ConfigComponentContract } from '@shared/utils/content-builder/config-component-contract';
import { computedResolvedConfig } from '@shared/utils/content-builder/block-config-computed-resolver';
import type { SocialLinksBlockConfig } from '@front-platform/content-builder';
import { socialLinksBlockResolveConfig } from '@front-platform/content-builder';
import { Component, input } from '@angular/core';
import { IContentBuilderFieldColor } from '@core/models/content-builder-fields.model';
export interface SocialLinksBlockRuntimeConfig {}

export type SocialLinksBlockConfigInput = Partial<
  Omit<SocialLinksBlockConfig, keyof SocialLinksBlockRuntimeConfig> & SocialLinksBlockRuntimeConfig
>;
export type SocialLinksBlockResolvedConfig = Omit<
  SocialLinksBlockConfig,
  keyof SocialLinksBlockRuntimeConfig
> &
  Partial<SocialLinksBlockRuntimeConfig>;
export interface SocialLinksBlockContract extends ConfigComponentContract<
  SocialLinksBlockConfigInput,
  SocialLinksBlockResolvedConfig
> {}

@Component({
  selector: 'app-social-links-block',
  templateUrl: './social-links-block.component.html',
  standalone: false,
})
export class SocialLinksBlockComponent implements SocialLinksBlockContract {
  readonly config = input<SocialLinksBlockConfigInput>({});
  readonly resolvedConfig = computedResolvedConfig<
    SocialLinksBlockConfig,
    SocialLinksBlockRuntimeConfig
  >(socialLinksBlockResolveConfig, () => ({ config: this.config() }));
  get facebookUrl(): string | undefined {
    return this.resolvedConfig()['facebook_url'] as unknown as string | undefined;
  }
  get twitterUrl(): string | undefined {
    return this.resolvedConfig()['twitter_url'] as unknown as string | undefined;
  }
  get instagramUrl(): string | undefined {
    return this.resolvedConfig()['instagram_url'] as unknown as string | undefined;
  }
  get linkedinUrl(): string | undefined {
    return this.resolvedConfig()['linkedin_url'] as unknown as string | undefined;
  }
  get googleUrl(): string | undefined {
    return this.resolvedConfig()['google_url'] as unknown as string | undefined;
  }
  get tiktokUrl(): string | undefined {
    return this.resolvedConfig()['tiktok_url'] as unknown as string | undefined;
  }
  get textColor(): IContentBuilderFieldColor | undefined {
    return this.resolvedConfig()['text_color'] as unknown as IContentBuilderFieldColor | undefined;
  }
}
COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS.set(SocialLinksBlockComponent, { 'keyAliases': {} });
